<template>
  <div style="background-color: #3e93ff;width: 100%;height: 100%;line-height: 60px;color: #ffffff">
    <div style="float: left;margin-left: 20px">图书视频后台管理系统</div>
    <div style="float: right;margin-right: 20px">
      <span>{{ '欢迎您，' + userName }}</span>
      <div style="float: right;cursor: pointer;margin-left: 40px" @click="logout">
        <img src="../../assets/img/exit.png" style="width: 14px;">
        退出登录
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navTon',
  data () {
    return {
      collapsed: true,
      userName: ''
    }
  },
  created () {
    this.userName = this.$store.state.user.userName
  },
  methods: {
    // 退出登录
    exit () {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    logout () {
      this.$store.dispatch('Logout').then(res => {
        // console.log(234)
        this.$router.push('/')
      }).catch(() => {
        this.$store.dispatch('FedLogOut')
        this.$router.push('/')
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/navTop.vue